import React, { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import TagDashboardWebPage from "./(web)/TagDashboardPage";
import useMediaView from "features/common/hooks/useMediaView";
import TagDashboardMobilePage from "./(mobile)/TagDashboardMobilePage";
import useTagsQuery from "features/tag/hooks/queries/useTagsQuery";

export interface TagDashboardFormData {
  search: string;
}

const TagDashboardPage = () => {
  const method = useForm<TagDashboardFormData>();
  const [searchOption, setSearchOption] = useState<TagDashboardFormData>({
    search: "",
  });
  const isSmall = useMediaView("small");

  const { data } = useTagsQuery({
    searchTerm: searchOption.search,
  });

  const tags = data.data.result;

  const handleSearch = (data: TagDashboardFormData) => {
    setSearchOption(data);
  };

  return (
    <FormProvider {...method}>
      <form onSubmit={method.handleSubmit(handleSearch)}>
        {!isSmall && <TagDashboardWebPage tags={tags} />}
        {isSmall && <TagDashboardMobilePage tags={tags} />}
      </form>
    </FormProvider>
  );
};

export default TagDashboardPage;
